import { SCAN_JURISDICTIONS } from '/b2b/domains/constants';

export const getScanResultStatus = result => {
    if (result?.status === 'error' || result?.status === 'in_progress') return result.status;

    const jurisdiction = result?.jurisdictions?.[SCAN_JURISDICTIONS.CALIFORNIA] || {};

    if (jurisdiction.status === 'error') return 'error';
    if (jurisdiction.status === 'warning') return 'warning';

    return result?.status || 'failed';
};
